module.exports = __webpack_public_path__ + "static/media/drag-image.76a1f1f6.svg";